export default __webpack_public_path__ + "static/media/hero-bg.0fde46a9.png";